// Libs
import { createSlice } from '@reduxjs/toolkit';
// Others
import { createAppointment, detailAppointment, updateAppointment } from './appointmentThunk';

export interface IAppointmentState {}

export const initialState: IAppointmentState = {};

const appointmentSlice = createSlice({
  name: 'appointment',
  initialState,
  reducers: {},
  extraReducers(builder) {
    // POST: Create appointment
    builder
      .addCase(createAppointment.pending, (_state) => {})
      .addCase(createAppointment.fulfilled, (_state) => {})
      .addCase(createAppointment.rejected, (_state) => {});

    // GET: Detail appointment
    builder
      .addCase(detailAppointment.pending, (_state) => {})
      .addCase(detailAppointment.fulfilled, (_state) => {})
      .addCase(detailAppointment.rejected, (_state) => {});

    // PUT: Update appointment
    builder
      .addCase(updateAppointment.pending, (_state) => {})
      .addCase(updateAppointment.fulfilled, (_state) => {})
      .addCase(updateAppointment.rejected, (_state) => {});
  },
});

// Action
export const appointmentActions = appointmentSlice.actions;

// Selectors

// Reducer
const appointmentReducer = appointmentSlice.reducer;
export default appointmentReducer;
